export const JCA_CUSTOM_COMBOS_IDS = ['gremios_ip']
